export const fileExtensions = ["jpg", "jpeg", "png", "doc", "docx", "pdf", "xls", "xlsx"]
